import {PageItem_TextContentBlock} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/story_page/v1/service.types';
import {
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  SPACING,
  gridCols,
  mediaLargeScreens,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

/**
 * Set by `StoryHeadline` so this block can recognise a headline it directly follows.
 */
export const HEADLINE_BLOCK = 'headline';

export const StoryText: React.FC<{
  content: PageItem_TextContentBlock;
  testId?: string;
}> = ({content, testId = 'storyText'}) => {
  if (content.text === '') return null;

  return <Text data-testid={testId}>{content.text}</Text>;
};

const Text = styled.p`
  margin: ${SPACING['Y.Md']} 0 ${SPACING['Y.Lg']};
  color: ${COLORS.Black};
  font-size: ${FONT_SIZES.px14};
  font-weight: ${FONT_WEIGHTS.w400};
  line-height: ${FONT_SIZES.px20};
  text-align: center;
  white-space: pre-line;
  word-break: break-word;

  @media ${mediaLargeScreens} {
    ${gridCols(6)}
    padding-inline: ${SPACING['X.Lg']};
    margin: ${SPACING['Y.Lg']} auto ${SPACING['Y.Xl']};
  }
`;
